import { render } from "./splash-screen.vue?vue&type=template&id=11d31a81"
import script from "./splash-screen.vue?vue&type=script&lang=js"
export * from "./splash-screen.vue?vue&type=script&lang=js"

import "./splash-screen.vue?vue&type=style&index=0&id=11d31a81&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__